





























import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator";
import SliderToggler from "_C/main/Step4/SliderToggler.vue";
import CarForm from "_C/main/FormParts/CarForm.vue";
import { RecentCardsHelper } from "@/core/helpers/RecentCardsHelper";
import { DefaultCopy } from "_P/copyobj";
import {
    InsuranceCard,
    Car,
    ModelResponse,
    ModificationResponse
} from "@/services/index.defs";
import { CarDocumentType } from "@/models/Models";
@Component({
    components: { CarForm, SliderToggler }
})
export default class CarDisplay extends Vue {
    get placeholderData(): any[] {
        let vin, bodyId, chassisId;
        const protectedCarId = this.$store.direct.state.insurance
            .protectedCarId;
        if (protectedCarId == this.car.vin) vin = this.car.vin?.hideCenter?.(3);
        else vin = this.car.vin;

        if (protectedCarId == this.car.vin)
            bodyId = this.car.bodyNumber?.hideCenter?.(3);
        else bodyId = this.car.bodyNumber;
        if (protectedCarId == this.car.vin)
            chassisId = this.car.chassisNumber?.hideCenter?.(3);
        else chassisId = this.car.chassisNumber;

        return [
            { title: "Рег знак: ", val: this.car.licensePlate },
            { title: "VIN: ", val: vin },
            { title: "Кузов: ", val: bodyId },
            { title: "Шасси: ", val: chassisId },
            {
                title: "Марка и модель: ",
                val: RecentCardsHelper.createCardName(this.$store, this.card)
            },
            { title: "Год выпуска: ", val: this.car.yearIssue },
            { title: "Мощность: ", val: this.car.power },
            {
                title: `Серия и номер ${this.getDocTitle(
                    this.car.documentCar.docTypeId
                )}: `,
                val: `${this.car.documentCar.seria} ${this.car.documentCar.number}`
            },
            {
                title: "Дата выдачи: ",
                val:
                    this.car.documentCar?.docDate?.toLocaleDateString?.() ??
                    "--"
            }
        ];
    }

    get card(): InsuranceCard {
        return this.$store.direct.state.insurance.card;
    }
    get car(): Car {
        return this.card.car;
    }
    getDocTitle(doc: CarDocumentType) {
        switch (+doc) {
        case CarDocumentType.PTS:
            return "ПТС";
        case CarDocumentType.EPTS:
            return "ЭПТС";
        case CarDocumentType.STS:
            return "СТС";
        default:
            return "Не определено";
        }
    }

    currMapModels: ModelResponse[] = [];
    currModifications: ModificationResponse[] = [];
    editStateChanged(val) {
        if (val) {
            this.currMapModels = this.$store.direct.state.dicti.mapModels;
            this.currModifications = this.$store.direct.state.dicti.modifications;
        }
    }

    fakeCar: Car = DefaultCopy(this.car);
    @Ref("form") form: { validate: Function };
    applyChanges() {
        let isValid = this.form.validate();
        if (!isValid) {
            this.cancelChanges();
        } else {
            this.card.car = DefaultCopy(this.fakeCar);
        }
    }
    cancelChanges() {
        this.fakeCar = DefaultCopy(this.car);
        this.$store.direct.commit.dicti.setMapModels(this.currMapModels);
        this.$store.direct.commit.dicti.setModification(this.currModifications);
    }

    @Ref("st") st: SliderToggler;
    isEdit(): boolean {
        return this.st.isEdit;
    }
}
